// Approximate Zerodha intraday equity charges for one round trip (paper estimate).
export const charges = (side, qty, entry, exit) => {
  qty = Number(qty); entry = Number(entry); exit = Number(exit);
  if (!qty || !entry || !exit) return 0;
  const a = qty*entry, b = qty*exit, buy = side === 'LONG' ? a : b, sell = side === 'LONG' ? b : a;
  const brk = Math.min(20, 0.0003*buy) + Math.min(20, 0.0003*sell), exch = 0.0000297*(buy + sell), sebi = 0.000001*(buy + sell);
  return brk + 0.00025*sell + exch + sebi + 0.18*(brk + exch + sebi) + 0.00003*buy;
};
